import {
  constants,
  typographyStyles,
  cssVariableStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { generateIconColorCss } = cssVariableStyles;
const redIcon = generateIconColorCss({
  primaryColor: constants.colors.ui.red[600],
});
const spacing = "0.5rem";
const red = constants.colors.ui.red[600];
const grey = constants.colors.ui.neutral[500];
const greyExtraLight = constants.colors.ui.neutral[25];
const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md },
} = constants.breakpoints;

export const assigneeModalbuttonRowCss = {
  ">*": {
    marginLeft: spacing,
  },
};

export const assigneeModalbuttonContainer = {
  display: "flex",
  justifyContent: "space-between",
};

export const assigneeModalErrorCss = [
  {
    display: "flex",
    color: red,
    fontSize: "14px",
    svg: {
      width: "14px",
    },
  },
  redIcon,
];

export const modalContentWrapperCss = (headerHeight) => ({
  maxWidth: "800px !important",
  maxHeight: "582px !important",
  display: "grid",
  gridTemplateRows: "auto 1fr auto",
  "&&": {
    [mediaQuery.downTo(md)]: {
      marginTop: headerHeight,
    },
  },
});

export const assigneeTypeTitleCss = {
  margin: "8px 0 32px",
};

export const footerRowCss = {
  minHeight: "auto",
};

export const checkboxStyles = {
  "*": {
    boxSizing: "content-box",
  },
};

export const classlistContainerCss = [
  typographyStyles.textXSObj,
  {
    padding: "0",
  },
];

export const accordionCss = {
  h3: {
    fontWeight: "normal",
  },
};

export const noStudentsMessageCss = {
  color: grey,
  backgroundColor: greyExtraLight,
  padding: "10px",
  margin: "0",
};

export const sgaCheckboxStyles = {
  padding: "12px 16px",
  "*": {
    boxSizing: "content-box",
  },
};

export const sgaClasslistItemCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "8px",
};
